var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { fixedForwardRef } from "../../../common/LibComponentProps";
var UnwrappedCol = function (props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var _a = props.as, Component = _a === void 0 ? "div" : _a, children = props.children, col = props.col, sm = props.sm, md = props.md, lg = props.lg, xl = props.xl, offset = props.offset, offsetSm = props.offsetSm, offsetMd = props.offsetMd, offsetLg = props.offsetLg, offsetXl = props.offsetXl, offsetRight = props.offsetRight, offsetRightSm = props.offsetRightSm, offsetRightMd = props.offsetRightMd, offsetRightLg = props.offsetRightLg, offsetRightXl = props.offsetRightXl, verticalAlign = props.verticalAlign, className = props.className, style = props.style, otherProps = __rest(props, ["as", "children", "col", "sm", "md", "lg", "xl", "offset", "offsetSm", "offsetMd", "offsetLg", "offsetXl", "offsetRight", "offsetRightSm", "offsetRightMd", "offsetRightLg", "offsetRightXl", "verticalAlign", "className", "style"]);
    var classCol = "";
    var getFrClassCol = function (classSufix) {
        if (classCol === "") {
            classCol = "fr-col-".concat(classSufix);
        }
        else {
            classCol += " fr-col-".concat(classSufix);
        }
    };
    if (!col &&
        !sm &&
        !md &&
        !lg &&
        !xl &&
        !offset &&
        !offsetSm &&
        !offsetMd &&
        !offsetLg &&
        !offsetXl &&
        !offsetRight &&
        !offsetRightSm &&
        !offsetRightMd &&
        !offsetRightLg &&
        !offsetRightXl) {
        classCol = "fr-col";
    }
    else {
        if (col)
            getFrClassCol("" + col);
        if (sm)
            getFrClassCol("sm-" + sm);
        if (md)
            getFrClassCol("md-" + md);
        if (lg)
            getFrClassCol("lg-" + lg);
        if (xl)
            getFrClassCol("xl-" + xl);
        if (offset)
            getFrClassCol("offset-" + offset);
        if (offsetSm)
            getFrClassCol("offset-sm-" + offsetSm);
        if (offsetMd)
            getFrClassCol("offset-md-" + offsetMd);
        if (offsetLg)
            getFrClassCol("offset-lg-" + offsetLg);
        if (offsetXl)
            getFrClassCol("offset-xl-" + offsetXl);
        if (offsetRight)
            getFrClassCol("offset-" + offsetRight + "--right");
        if (offsetRightSm)
            getFrClassCol("offset-sm-" + offsetRightSm + "--right");
        if (offsetRightMd)
            getFrClassCol("offset-md-" + offsetRightMd + "--right");
        if (offsetRightLg)
            getFrClassCol("offset-lg-" + offsetRightLg + "--right");
        if (offsetRightXl)
            getFrClassCol("offset-xl-" + offsetRightXl + "--right");
    }
    if (verticalAlign) {
        if (verticalAlign === "center") {
            getFrClassCol("-middle");
        }
        else {
            getFrClassCol("-" + verticalAlign);
        }
    }
    if (className) {
        classCol += " ".concat(className);
    }
    return (React.createElement(Component, __assign({}, otherProps, { className: classCol, ref: ref, style: style }), children));
};
var Col = fixedForwardRef(UnwrappedCol);
export default Col;
